import { Dialog, DialogContent, Typography, Box, Stack } from "@mui/material";
import { useState } from "react";
import ImageAssets from "../../../assets";
import { MuiButton } from "../../../components/common/button/MuiButton";
import { MuiCheckbox } from "../../../components/common/checkbox/MuiCheckBox";
import styles from "./EventDetails.module.css";

const RefundPolicy = ({ open, onClose, handleRefundBtn, infoPopup }: any) => {

    const [terms, setTerms] = useState(false);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogContent className={styles.dialogContent}>
                <Typography variant="h6" className={styles.heading}>
                    Sekeron Open Mic Refund Policy
                </Typography>

                <Box className={styles.policyText}>
                    <Typography paragraph>
                        We get it—plans can change last minute. Here’s how our refund policy works:
                    </Typography>

                    <ol className={styles.policyList}>
                        <li>
                            <strong>Full Refund</strong>
                            <p>• Cancel at least 6 hours before the event to get a 100% refund.</p>
                        </li>
                        <li>
                            <strong>Partial Refund</strong>
                            <p>• Cancel between 2 to 6 hours before the event to receive a 50% refund.</p>
                        </li>
                        <li>
                            <strong>No Refund</strong>
                            <p>• Cancel less than 2 hours before the event or miss it entirely—no refund will be issued.</p>
                        </li>
                        <li>
                            <strong>Event Cancellation by Sekeron</strong>
                            <p>• If we cancel or reschedule the event, you’ll receive a full refund or can transfer your spot to a future event.</p>
                        </li>
                    </ol>

                    <Typography paragraph>
                        Refunds will be processed within 5–7 business days to your original payment method.
                    </Typography>

                    <Typography paragraph>
                        For any queries, please contact us through Help Section.
                    </Typography>
                </Box>

                {!infoPopup ?
                    <>
                        <Box className={styles.actions}>
                            <MuiCheckbox
                                uncheckedIcon={ImageAssets.ic_checkbox_unchecked}
                                checkedicon={ImageAssets.ic_checkbox_checked}
                                checked={terms}
                                onChange={(e) => setTerms(e?.target?.checked)}
                            />
                            <Typography variant="body2" className={styles.checkboxLabel}>
                                By clicking continue button, you agreed to our refund policy.
                            </Typography>
                        </Box>

                        <Stack justifyContent={'right'}>
                            <MuiButton className={styles["pay-button"]} disabled={!terms} onClick={handleRefundBtn}>Continue</MuiButton>
                        </Stack>
                    </>
                    : ''
                }
            </DialogContent>
        </Dialog>
    );
};

export default RefundPolicy;
